import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {ReactLenis} from "lenis/react"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <ReactLenis root>
    <App />
  </ReactLenis>
  </BrowserRouter>

);
reportWebVitals();
